import { useNavigate } from 'react-router-dom';
import { LogIn, Sparkles, Home } from 'lucide-react';

const LoginPrompt = ({ title = '需要登录', description = '登录后即可使用此功能' }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-[50vh] flex items-center justify-center px-4">
      <div className="frost p-8 text-center max-w-sm w-full" style={{ animation: 'rise .75s ease-out both' }}>
        <div className="flex justify-center mb-5">
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: 'rgba(106,179,214,0.12)', border: '1px solid rgba(106,179,214,0.2)' }}>
            <LogIn className="w-8 h-8 cg" />
          </div>
        </div>
        <h3 className="text-xl font-bold cb mb-2">{title}</h3>
        <p className="text-sm cm mb-6">{description}</p>
        <button onClick={() => navigate('/login')} className="btl w-full py-3 flex items-center justify-center gap-2">
          <Sparkles className="w-4 h-4" /> 去登录
        </button>
        <button onClick={() => navigate('/')} className="mt-4 text-sm cd hover:!cb transition flex items-center justify-center gap-1 mx-auto">
          <Home className="w-3.5 h-3.5" /> 先逛逛首页
        </button>
      </div>
    </div>
  );
};

export default LoginPrompt;
